import { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import RuleEngineBackend from "../../services/RuleEngineBackend";
import PPUtils from "../../../utils/PPUtils";

export default function PPBackupRuleSelectionModal({ visible, close, onSelect }) {
     const [backupRules, setBackupRules] = useState([]);
     const [selectedRule, setSelectedRule] = useState(null);
     const [isLoading, setIsLoading] = useState(false);

     const auth = PPUtils.getLogin();
     const token = auth.token;
     const customerId = PPUtils.getEffectiveCustomerId(auth);

     useEffect(() => {
          if (visible) {
               fetchBackupRules();
          }
     }, [visible]);

     const fetchBackupRules = async () => {
          setIsLoading(true);
          try {
               const rules = await RuleEngineBackend.getBackupRules(token, customerId);
               setBackupRules(rules || []);
          } catch (error) {
               console.error("Error fetching backup rules:", error);
               setBackupRules([]);
          } finally {
               setIsLoading(false);
          }
     };

     const handleConfirm = () => {
          if (onSelect) {
               onSelect(selectedRule);
          }
          handleClose();
     };

     const handleClose = () => {
          setSelectedRule(null);
          close();
     };

     return (
          <Dialog
               header={
                    <span className="d-flex align-items-center">
                         <i className="fas fa-shield-alt me-2"></i>{' '}Backup-Regel auswählen
                    </span>
               }
               visible={visible}
               style={{ width: "50rem" }}
               onHide={handleClose}
               dismissableMask
               footer={
                    <div className="d-flex justify-content-end gap-2">
                         <button type="button" className="btn btn-secondary" onClick={handleClose}>
                              Abbrechen
                         </button>
                         <button type="button" className="btn btn-primary" onClick={handleConfirm} disabled={isLoading}>
                              <i className="fas fa-check me-2"></i>
                              {selectedRule ? "Backup-Regel hinzufügen" : "Ohne Backup-Regel fortfahren"}
                         </button>
                    </div>
               }>
               {isLoading ? (
                    <div className="text-center py-4">
                         <output className="spinner-border mb-3">
                              <span className="visually-hidden">Loading...</span>
                         </output>
                         <div>Backup-Regeln werden geladen...</div>
                    </div>
               ) : backupRules.length === 0 ? (
                    <div className="text-center py-4">
                         <i className="fas fa-exclamation-triangle fs-1 text-warning mb-3"></i>
                         <h6>Keine Backup-Regeln verfügbar</h6>
                         <p className="text-muted">Es sind keine Backup-Regeln für diesen Kunden vorhanden.</p>
                    </div>
               ) : (
                    <div>
                         <p className="mb-3">Wählen Sie eine Backup-Regel aus der Liste:</p>
                         <div className="row">
                              {backupRules.map((rule) => (
                                   <div key={rule.id} className="col-12 mb-3">
                                        <button
                                             type="button"
                                             className={`card h-100 pp-rule-selection-card ${selectedRule?.id === rule.id ? "border-primary border-3 pp-rule-selection-card--selected" : "border-secondary"}`}
                                             style={{
                                                  cursor: "pointer",
                                                  backgroundColor: selectedRule?.id === rule.id ? "#e3f2fd" : "white",
                                                  textAlign: "left",
                                                  width: "100%",
                                                  padding: 0
                                             }}
                                             onClick={() => {
                                                  if (selectedRule?.id === rule.id) {
                                                       setSelectedRule(null);
                                                  } else {
                                                       setSelectedRule(rule);
                                                  }
                                             }}>
                                             <div className="card-body">
                                                  <div className="d-flex align-items-center justify-content-between">
                                                       <div className="flex-grow-1">
                                                            <h6 className="card-title mb-2 text-dark">{rule.name}</h6>
                                                            <p className="card-text text-muted mb-0">{rule.description}</p>
                                                       </div>
                                                       {selectedRule?.id === rule.id && (
                                                            <div className="ms-3">
                                                                 <i className="fas fa-check-circle text-primary fs-4"></i>
                                                            </div>
                                                       )}
                                                  </div>
                                             </div>
                                        </button>
                                   </div>
                              ))}
                         </div>
                    </div>
               )}
          </Dialog>
     );
}
